import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createResults } from '../state/actions/results';
import "confetti-js/dist/index.min";
import Background from './visuals';
import Sections from './sections';

@connect(
	state => {
		return {
			setupData: state.setup,
			appView: state.appView,
			userData: state.user,
		}
	},
	dispatch => {
		return {
			createResults: async (body) => {
				dispatch(createResults(body))
			}
		}
	}
)
export default class Game extends Component {

	static PropTypes = {};

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { userData } = this.props;
		return this.props.appView === 'game' ? (
			<div className="game">
				<Background />

				<Sections sectionsData={this.props.setupData} />
				<canvas id={'confetti'} />
			</div>
		) : null;
	}
}
